import { render } from "./DashboardNavBar.vue?vue&type=template&id=34545cf2"
import script from "./DashboardNavBar.vue?vue&type=script&lang=js"
export * from "./DashboardNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__